import Vue from 'vue'
import Toasted from 'vue-toasted'
import InfiniteLoading from 'vue-infinite-loading'
import Sticky from 'vue-sticky-directive'
import Vue2DatePicker from 'vue2-datepicker';
import vSelect from 'vue-select'
import 'vue2-datepicker/index.css';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules';
import AppInput from './form/Input.vue';
import AppSelect from './form/Select.vue';
import AppTextarea from './form/Textarea.vue';
import AppFileUpload from './form/FileUpload.vue';
import AppToggle from './form/Toggle.vue';
import AppCard from './Card.vue';
import AppLoader from './Loading.vue'
import AppButton from './Button.vue'
import AppAlert from './Alert.vue'
import AppHeader from './Header.vue';
import AppDatepicker from './form/Datepicker.vue';
import AppTimepicker from './form/Timepicker.vue';
import AppConfirmModal from './modal/Confirm.vue';

for (let rule in rules) {
    extend(rule, (rules as any)[rule]);
}

Vue.component('vue-select', vSelect)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(Sticky)
Vue.use(InfiniteLoading, {
    slots: {
        noMore: 'No more',
        noResults: 'No data found'
    }
} as any)
Vue.use(Toasted, {
    position: 'top-center',
    duration: 2500
})

Vue.component("date-picker", Vue2DatePicker as any)

// Form
Vue.component('app-input', AppInput)
Vue.component('app-textarea', AppTextarea)
Vue.component('app-file-upload', AppFileUpload)
Vue.component('app-toggle', AppToggle)
Vue.component('app-select', AppSelect)
Vue.component('app-datepicker', AppDatepicker)
Vue.component('app-timepicker', AppTimepicker)
Vue.component('app-card', AppCard)
Vue.component('app-header', AppHeader)
Vue.component('app-alert', AppAlert)
Vue.component('app-loader', AppLoader)
Vue.component('app-button', AppButton)
Vue.component('app-confirm-modal', AppConfirmModal)
